import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/faq";

export const List = async (values) => {
    return await axiosInstance(options).get(`${path}/list${objToURL(values)}`);
}

export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}`, values);
}

export const Edit = async (values,id) => {
    return await axiosInstance(options).put(`${path}/${id}`, values);
}

export const Delete = async (id) => {
    return await axiosInstance(options).delete(`${path}/${id}`)
}

export const Details = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}`);
}

export const Status = async (values,id) => {
    return await axiosInstance(options).patch(`${path}/status/${id}`, values)
}

